export default __webpack_public_path__ + "static/media/error.7ff9ccd0.mp3";